import { configHelper, createSupportLink, useConfigHelper } from '@ilteducation/config';

export const getGroupCodeAndPasswordHelpURL = (): string => {
  const realm = useConfigHelper().getRealm();

  switch (realm) {
    case 'de':
      return 'https://support.ilteducation.de/kb/guide/de/wegweiser-beim-start-mit-polylino-schule-uNkX5ksrmQ/Steps/4393348,4393416,4393375';
    case 'se':
      return 'https://support.ilteducation.se/kb/guide/sv/skapa-en-gruppkod-och-losenord-steg-for-steg-LKnAxVanyX/Steps/3381766';
    default:
      return createSupportLink(realm);
  }
};

export const getPanelUrl = () => {
  return configHelper.getUrl('panel').replace('inlasningstjanst', 'ilteducation');
};
